import { Box } from '@mantine/core';
import { ErrorRouteComponent } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { CommonError } from '@ui';

export const DefaultErrorPage: ErrorRouteComponent = ({ error, reset }) => {
  const { t } = useTranslation();

  return (
    <Box h="100%" w="100%">
      <CommonError
        description={t('common.error.pageError')}
        error={error}
        reset={reset}
      />
    </Box>
  );
};
